<template>
    <div id="betslipAnchor" class="betslip-container full-height">
        <v-tabs color="#643e94" fixed-tabs>
            <v-tab class="betslip-tab">
                Bet Slip
            </v-tab>
        </v-tabs>
        <div class="remove-all-bets" v-if="$store.getters.betSelection.length > 0">
            <a @click="removeAllBets()" :class="{removeAllBtn : $store.getters.isSubmitting}">
                Remove All
            </a>
        </div>
        <div class="betSlip">
            <div class="header">
                <template v-if="hasBets">
                    <div v-for="(selection, index) in betSelections" :key="selection.marketId">
                        <BetSlipItem :betSelection="selection" :betSubmit="betSubmitSingle" :removeBet="removeBet" :calculatePayout="calculatePayout" :betLeg="index + 1"></BetSlipItem>
                    </div>
                    <MultiBetItem :betSelections="betSelections" :betSubmit="betSubmitMultiple" v-if="!hasRelatedEvents() && betSelections && betSelections.length > 1"></MultiBetItem>
                </template>
                <div v-else class="empty-message">Add selections to your bet slip</div>
            </div>
            <div class="minStake">*Min. stake MZ 20.00</div>
            <div class="footer" v-if="betSelections !== null">
                <v-select v-if="hasBets" v-model="selectedOddsChange" class="odds-select" :items="oddsChange" v-on:change="setOddsPreference" dark dense color="gold" placeholder="Select Option" prepend-icon="check_circle" label="Odds options"></v-select>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { HubConnection } from "@aspnet/signalr";
    import BetSlipItem from './BetSlipItem.vue';
    import MultiBetItem from './MultiBetItem.vue';
    import BetSlipApi from '@/api/BetSlip'
import { isNullOrUndefined } from 'util';

    export default {
        name: 'BetSlip',
        components: {
            BetSlipItem,
            MultiBetItem
        },
        data() {
            return {
                betSuccessResponse: '',
                betErrorResponse: '',
                totalOdds: 0.00,
                totalStake: 0.00,
                totalPayout: 0.00,
                error: false,
                timeout: false,
                countdown: 10,
                submitText: 'Submit Bet',
                oddsChange: [
                    'Accept any odds change', 'Accept higher odds change', "Don't accept odds changes"
                ]
            }
        },
        props: {
            connection: HubConnection,
        },
        watch: {
            sport: function (newSport, oldSport) {
                if (newSport !== oldSport) {
                    if (this.connection) {
                        if (oldSport) {
                            this.connection.off(oldSport + "_marketDetailUpdate");
                        }
                        this.connection.on(newSport + "_marketDetailUpdate", (value) => {
                            this.updateMarketDetail(JSON.parse(value));
                        });
                    }
                }
            }
        },
        filters: {
            currency(amount) {
                const amt = Number(amount)
                return amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 }) || '0.00'
            }
        },
        computed: {
            betSelections() {
                let selection = this.$store.getters.betSelection;
                if (selection !== undefined && selection.length > 0) {
                    return selection;
                }
                else {
                    return '';
                }
            },
            hasBets() {
                let selection = this.$store.getters.betSelection;
                if (selection !== undefined && selection.length > 0) {
                    return true;
                }
                return false;
            },
            punterId() {
                return this.$store.getters.punterId;
            },
            sport() {
                let selection = this.betSelections;
                return selection !== undefined && selection.length > 0 ? selection[0] && selection[0].sport : '';
            },
            selectedOddsChange: {
                get: function () {
                    return this.$store.getters.selectedOddsChange;
                },
                set: function (value) {
                    this.$store.dispatch('setselectedOddsChange', value);
                }
            }
        },

        methods: {
            removeAllBets() {
                this.$store.dispatch('removeAllBets');
                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false, accepted: false });
            },
            setOddsPreference(value) {
                this.$store.dispatch('setselectedOddsChange', value);
            },
            updateMarketDetail(updatedMarketDetail) {
                for (let item of this.betSelections) {
                    if (item.marketDetailId === updatedMarketDetail.MarketDetailID) {
                        if (item.marketDetailStatus !== updatedMarketDetail.Status) {
                            item.marketDetailStatus = updatedMarketDetail.Status;
                        }
                        if (updatedMarketDetail.Price > item.betleg.odds) {
                            Vue.set(item, 'css', 'oddIncrease');
                            item.betleg.odds = updatedMarketDetail.Price;
                            if (!item.betleg.submitting) {
                                this.$store.dispatch('setPayoutAmount', item.betleg);
                            }                    
                        } else if (updatedMarketDetail.Price < item.betleg.odds) {
                            Vue.set(item, 'css', 'oddDecrease');
                            item.betleg.odds = updatedMarketDetail.Price;
                            if (!item.betleg.submitting) {
                                this.$store.dispatch('setPayoutAmount', item.betleg);
                            } 
                        }
                        else {
                            Vue.set(item, 'css', '');
                        }
                    }
                }
            },
            betSubmitSingle(betSelection) {
                const betCriteria = this.initializeBetCriteria();
                betCriteria.punterId = this.punterId;
                betCriteria.priceChangeDrift = this.getPriceDrift(betCriteria);
                //Submit Single
                if (isNullOrUndefined(betSelection)) {
                    this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: true, errorMessage: 'No bet selected', submitting: false });
                    return;
                }
                betCriteria.betLegs.push(betSelection);
                betCriteria.betLegs[0].betleg.odds = betSelection.betleg.odds;
                betCriteria.totalOdds = betSelection.betleg.odds;
                betCriteria.betLegs[0].betleg.stake = betSelection.betleg.stake;
                betCriteria.totalStake = betSelection.betleg.stake;
                betCriteria.betLegs[0].betleg.payout = betSelection.betleg.stake * betSelection.betleg.odds; 
                betCriteria.totalPayout = betCriteria.betLegs.payout;

                if (this.$store.getters.accessToken !== null) {
                    BetSlipApi.submitBet(betCriteria)
                        .then(data => {
                            if (data.responseType === 1) {
                                this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: true, error: false, errorMessage: '', submitting: false });
                            } else {
                                if (data.responseObject && data.responseObject[0].returnID === 6 || data.responseObject && data.responseObject[0].returnID === 13) {
                                    let errorMsg = data.responseObject[0].returnMessage;
                                    let pos = errorMsg.indexOf(',');
                                    let displayMsg = errorMsg.substring(pos + 1)
                                    this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: true, errorMessage: displayMsg, submitting: false });
                                }
                                this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: true, errorMessage: data.responseMessage, submitting: false });
                            }
                        })
                        .catch(error => this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: true, errorMessage: error, submitting: false }))
                        .finally(() => {
                        })
                } else {
                    this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: true, errorMessage: 'You need to be logged in to submit a bet', submitting: false });
                }
                
            },
            betSubmitMultiple(betSelections) {
                let betCriteria = this.initializeBetCriteria();
                betCriteria.punterId = this.punterId;
                betCriteria.priceChangeDrift = this.getPriceDrift(betCriteria);
                if (isNullOrUndefined(betSelections)) {
                    this.$store.dispatch('setMultipleSubmission', { success: false, error: true, errorMessage: 'No bets selected', submitting: false });
                    return;
                }
                const multipleInfo = this.$store.getters.getMultipleTotals;
                betCriteria.totalOdds = multipleInfo.multipleTotals.totalOdds;
                betCriteria.totalStake = multipleInfo.multipleTotals.totalStake;
                betCriteria.totalPayout = multipleInfo.multipleTotals.totalPayout;
                betCriteria.betLegs = betSelections;
                for (let i = 0; i < betCriteria.betLegs.length; i++) {
                    betCriteria.betLegs[i].betleg.betLegNumber = i + 1;
                }
                if (this.$store.getters.accessToken !== null) {
                    BetSlipApi.submitBet(betCriteria)
                        .then(data => {
                            if (data.responseType === 1) {
                                this.$store.dispatch('setMultipleSubmission', { success: true, error: false, errorMessage: '', submitting: false });
                                this.$store.dispatch('updateMultipleTotals', {
                                    totalStake: 0,
                                    totalOdds: 0,
                                    totalPayout: null
                                });
                            } else {
                                if (this.$store.getters.getMultipleError) {
                                    this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false });
                                }
                                this.$store.dispatch('setMultipleSubmission', { success: false, error: true, errorMessage: data.responseMessage, submitting: false });
                            }
                        })
                        .catch(error => {
                            if (this.$store.getters.getMultipleError) {
                                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false });
                            }
                            this.$store.dispatch('setMultipleSubmission', { success: false, error: true, errorMessage: error, submitting: false });
                        })
                        .finally(() => {
                        });
                } else {
                    if (this.$store.getters.getMultipleError) {
                        this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false });
                    }
                    this.$store.dispatch('setMultipleSubmission', { success: false, error: true, errorMessage: 'You need to be logged in to submit a bet', submitting: false });
                }
            },
            removeBet(betSelection) {
                this.$store.dispatch('removeBet', betSelection.marketDetailId);
                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false, accepted: false });
                this.$store.dispatch('setAcceptedChanges', betSelection);
            },
            hasRelatedEvents() {
                return this.$store.getters.hasRelatedEvents;
            },
            calculatePayout(stake, odds) {
                if (stake && odds > 0)
                    return stake * odds;
                return 0;
            },

            getPriceDrift(betCriteria) {
                betCriteria.priceChangeDrift = this.$store.getters.selectedOddsChange;
                if (betCriteria.priceChangeDrift === this.oddsChange[0]) {
                    betCriteria.priceChangeDrift = 3;
                }
                else if (betCriteria.priceChangeDrift === this.oddsChange[1]) {
                    betCriteria.priceChangeDrift = 2;
                }
                else if (betCriteria.priceChangeDrift === this.oddsChange[2]) {
                    betCriteria.priceChangeDrift = 1;
                }
                return betCriteria.priceChangeDrift;
            },
            initializeBetCriteria() {
                return {
                    punterId: -1,
                    totalOdds: 0.00,
                    totalStake: 0.00,
                    totalPayout: 0.00,
                    priceChangeDrift: 0,
                    betLegs: []
                };
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .betslip-container {
        /*position: fixed;*/
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-weight: 600;
    }

    .betslip-btn {
        width: 100%;
        height: 100%;
        padding: 0px;
        margin: 0px;
    }

    .betslip-tab {
        text-transform: capitalize;
        font-weight: 400;
    }

        .betslip-tab a {
            cursor: default !important;
        }

    .betslip-item {
        color: #efefef;
        font-size: 12px;
        line-height: 19px;
        font-weight: normal;
    }

    .betslip-item-header {
        color: white;
        font-size: 15px;
        line-height: 17px;
        padding-bottom: 15px;
        text-align: left;
        text-transform: uppercase;
    }

    button {
        text-align: right;
    }

    .currency {
        padding: 0 10px 0 5px;
    }

    .total-stake, .currency {
        color: #ddd;
        line-height: 29px;
        font-size: 13px;
    }

    .empty-message {
        color: #ddd;
        font-size: 12px;
        text-align: center;
        line-height: 18px;
        padding: 32px 10px 32px 10px;
        background-color: #2b2b2b;
        font-weight: normal;
        cursor: default;
    }

    .material-icons {
        color: red;
        font-weight: bolder;
        vertical-align: middle;
        padding-top: 1px;
    }

    .odds-container {
        border-right: none;
        display: table-cell;
        position: relative;
    }

    .expanded .place-bet {
        display: inline-block;
        min-width: 45%;
        padding: 5px 5px 5px 0;
    }

    .remove-column {
        display: table-cell;
    }

    .remove-header {
        position: relative;
        background-color: #2b2b2b;
        padding: 0 10px 0 10px;
        text-align: left;
    }

    .expanded .selection {
        padding-bottom: 12px;
    }

    .primary--text {
        color: #ddd !important;
    }

    .selection {
        display: table-cell;
        vertical-align: top;
        width: 100%;
    }

    .btn-submit {
        width: 100%;
        margin: 0px 0px 20px 0px;
        color: white;
        display: inline-block;
        font-weight: 600;
    }

    .stake {
        font-weight: 100;
    }


    .footer {
        background-color: #2b2b2b;
        position: relative;
        font-size: 0;
    }

    ul {
        margin: 0;
        padding: 0;
        font-size: 0;
    }

    li {
        list-style: none;
    }

    .betSlip {
        background-color: #2b2b2b;
        padding: 10px;
    }

    ::placeholder {
        color: #fff;
    }

    :-ms-input-placeholder {
        color: #fff;
    }

    ::-ms-input-placeholder {
        color: #fff;
    }

    .application--wrap {
        min-height: 100% !important;
    }

    .remove-all-bets {
        background-color: #424242;
        text-align: right;
    }

        .remove-all-bets a {
            color: #fff;
            font-weight: normal;
            font-size: 11px;
            padding: 5px 10px;
            display: inline-block;
        }

            .remove-all-bets a:hover {
                background-color: #ea5b5b;
            }

    .removeAllBtn {
        pointer-events: none;
        cursor: default;
    }

        .removeAllBtn:hover {
            background-color: #424242;
        }

    .full-height {
        overflow: hidden auto;
        overflow-x: hidden;
        overflow-y: auto;
        height: 100vh;
    }

        .full-height::-webkit-scrollbar-track {
            box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
            background-color: #232323;
        }

        .full-height::-webkit-scrollbar {
            width: 10px;
            background-color: #d3d3d3;
        }

        .full-height::-webkit-scrollbar-thumb {
            background-color: #474747;
            border: 2px solid #474747;
        }

    .odds-select {
        margin-top: 5px;
    }

    .mt16 {
        margin-top: 16px !important;
    }

    .footer .v-input {
        font-size: 12px;
    }

    .minStake {
        color: #929292 !important;
        font-size: 11px;
        position: relative;
        padding-top: 5px;
    }
</style>
